import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { useTitleWithLocation } from './hooks/useTitleWithLocation';

export const TitleContainer: React.FC = () => {
	const title = useTitleWithLocation();

	return (
		<Helmet>
			<title>{title}</title>
		</Helmet>
	);
};
